import { ListFilter } from '../../../core/models/filter.model';
import { Language } from '../../../core/constants/ui-utils.constant';
import { ProgramType } from '../../../core/enum/webinar-course.enum';
import { UiProgramType } from '../../../core/enum/ui-utils.enum';
import { getUiProgramType } from '../../../core/models/webinar-course.model';
import { getProgramMainRoute } from '../../../core/components/webinar-course/webinar-course-helper';

export interface HomeBanner {
    id: number;
    imageUrl: string;
    bannerUrl: string;
}

export interface Article {
    id: number;
    imageUrl: string;
    publishedDate: string;
    title: string;
    description: string;
    categories: string[];
}

export interface FeaturedSeries {
    id: number;
    name: string;
    description: string;
}

export interface Banner {
    title: string;
    url: string;
    sequence: number;
    mobileImageUrl: string;
    tabletImageUrl: string;
    desktopImageUrl: string;
}

export interface UpComingClassesFilterInterface extends ListFilter {
    language: Language;
}

export class UpComingClassesFilterModel {
    language: Language;
    skip: number;
    take: number;
    paging: boolean;
    startDate: string;
    endDate: string;

    constructor(private model: UpComingClassesFilterInterface) {
        this.language = model.language;
        this.skip = model.skip || 0;
        this.take = model.take || 9;
        this.paging = model.paging || true;
        this.startDate = model.startDate || '';
        this.endDate = model.endDate || '';
    }
}

export interface LastLearningCourseInterface {
    programId: string;
    programTitle: string;
    progress: number;
    lastProgramChapter: string;
    lastProgramChapterId: string;
    remainingSeconds: number;
    programType: ProgramType;
}

export class LastLearningCourseModel {
    programId: string;
    programTitle: string;
    progress: number;
    lastProgramChapter: string;
    lastProgramChapterId: string;
    remainingMinutes: string;
    remainingSeconds: number;
    programType: ProgramType;
    uiProgramType: UiProgramType;
    mainRoute: string;

    constructor(private model: LastLearningCourseInterface) {
        this.programId = model.programId;
        this.programTitle = model.programTitle;
        this.progress = model.progress;
        this.lastProgramChapter = model.lastProgramChapter;
        this.lastProgramChapterId = model.lastProgramChapterId;
        this.remainingSeconds = model.remainingSeconds;
        this.remainingMinutes = this.secondsToMinutes(model.remainingSeconds);
        this.programType = model.programType ?? ProgramType.Course;
        this.uiProgramType = getUiProgramType(this.programType, null as any);
        this.mainRoute = getProgramMainRoute(this.uiProgramType);
    }

    private secondsToMinutes(seconds: number): string {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        return `${minutes}:${remainingSeconds}`;
    }
}
